import React from "react";
import { motion } from "framer-motion";

const CHAPTERS = [
  {
    n: "01",
    title: "We measure before we quote.",
    body: "Every job starts with a ladder on the ground and a tape measure on the fascia. No SMS quotes. No guesses off Google Maps.",
  },
  {
    n: "02",
    title: "We roll the metal on your driveway.",
    body: "Our seamless gutter machine sits in the truck. Every run is cut to your roof line the day it goes up. No shop seams. No shortcuts.",
  },
  {
    n: "03",
    title: "We design for Spokane weather.",
    body: "Snow load. Ice dams. Pine needles. Wind off the Palouse. We spec hangers, pitch, and guard mesh for the way water and weather actually move here.",
  },
  {
    n: "04",
    title: "We leave the yard clean.",
    body: "Tarps down. Magnetic sweep across every driveway. Debris off the property. If you find a nail after we leave, we come back the same day.",
  },
  {
    n: "05",
    title: "We answer the phone.",
    body: "A real person picks up between seven and six on weekdays. If you leave a message after hours, you get a call back the next morning.",
  },
];

const reveal = {
  hidden: { opacity: 0, y: 40 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: i * 0.08 },
  }),
};

export default function Manifesto() {
  return (
    <section
      data-testid="manifesto"
      className="relative py-16 md:py-40 bg-ink-950"
    >
      <div className="max-w-[1440px] mx-auto px-5 md:px-10">
        <div className="grid grid-cols-12 gap-6 mb-16 md:mb-24">
          <div className="col-span-12 md:col-span-4">
            <p className="overline mb-4">The manifesto</p>
          </div>
          <div className="col-span-12 md:col-span-8">
            <h2 className="font-display text-4xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tightest text-bone-50 max-w-3xl">
              Five things we hold to, every roof, every time.
            </h2>
          </div>
        </div>

        <div className="space-y-16 md:space-y-24">
          {CHAPTERS.map((c, i) => (
            <motion.article
              key={c.n}
              variants={reveal}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.35 }}
              custom={i}
              className="grid grid-cols-12 gap-4 md:gap-6 items-start border-t border-white/10 pt-10 md:pt-16"
            >
              <div className="col-span-12 md:col-span-4 relative">
                <span
                  aria-hidden
                  className="font-display text-[36vw] md:text-[13vw] lg:text-[11vw] leading-[0.85] tracking-tightest text-bone-50/[0.06] block"
                >
                  {c.n}
                </span>
                <span className="absolute top-3 left-0 md:left-2 overline">Chapter {c.n}</span>
              </div>
              <div className="col-span-12 md:col-span-8 md:pl-8 -mt-6 md:mt-0">
                <h3 className="font-display text-3xl md:text-5xl leading-[1.02] tracking-tightest mb-6">
                  {c.title}
                </h3>
                <p className="text-bone-300 text-base md:text-xl leading-relaxed max-w-2xl">
                  {c.body}
                </p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
